import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ACTION_DELETE_FEED, ACTION_FEED_STATUS, ACTION_UPDATE_SOCIAL_ACCOUNT } from '../../../../../actions/manageFeedsAction'
import FeedsRecord from './feedsRecord'
import Swal from 'sweetalert2'
import { getModeration } from '../../../../../actions/moderationActions';
import { refreshThemes } from '../../../../../actions/firstRunAction'
import { getWallFeeds } from '../../../../../actions/analyticsAction'

class FeedTable extends Component {
    state = {
        currentPage: 1, showPost: 10, totalPage: 1, allFeeds: [], currentPageFeeds: null, width: window.innerWidth, reconnectd: false,
        feed_datatable_length: [
            { label: "5", value: '5' },
            { label: "10", value: '10' },
            { label: "15", value: '15' },
            { label: "20", value: '20' },
            { label: "25", value: '25' },
            { label: "30", value: '30' },
            { label: "40", value: '40' },
            { label: "50", value: '50' },
        ]
    }



    handleResize = () => {
        this.setState({
            width: window.innerWidth
        })
    };

    componentDidMount() {
        this.countAllPage();
        this.handleResize();
        window.addEventListener('resize', this.handleResize)
    }

    componentWillUnmount() {
        window.addEventListener('resize', this.handleResize)
    }

    changeTotalPost = (e) => { this.setState({ showPost: parseInt(e.target.value), currentPage: 1 }, () => this.countAllPage()) }
    nextPrev = (no) => { this.setState({ currentPage: no }, () => this.countAllPage()) }

    countAllPage = () => {
        const { feeds } = this.props;

        var i = 0, newFeeddata = [], n = feeds.length
        while (i < n) { newFeeddata.push(feeds.slice(i, i += this.state.showPost)) }
        setTimeout(this.setState({ allFeeds: newFeeddata, totalPage: newFeeddata.length }), 100)
    }


    changeStatus = (feedId, status, action, postCount) => {
        this.props.ACTION_FEED_STATUS(feedId, status, action, postCount, this.onSuccessUpdateRedux)
    }


    changeAccount = (accountId, feedId) => {
        this.props.ACTION_UPDATE_SOCIAL_ACCOUNT(accountId, feedId, this.onSuccessUpdateRedux)
    }



    onFeedDelete = (feedId,postCount) => {
        Swal.fire({
            icon: 'warning',
            title: 'Are you sure?',
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: true,
            confirmButtonText: 'Yes',
            confirmButtonAriaLabel: 'Yes',
            cancelButtonText: 'No',
            cancelButtonAriaLabel: 'Thumbs down'
        }).then((result) => {
            if (result.value) {
                this.props.ACTION_DELETE_FEED(feedId, ()=>this.onSuccessUpdateRedux(postCount));
            }
            else if (result.dismiss === "cancel") { }
        });
    }

    onSuccessUpdateRedux = (postCount) => {

        setTimeout(() => {
            this.props.refreshThemes();
            if(window.location.href.includes('moderation')) this.props.getModeration();
            this.countAllPage();
            this.props.removePost();
        }, 100);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.feeds !== this.props.feeds) {
            this.countAllPage();
        }
    }

    render() {
        const { currentPage, showPost, totalPage, allFeeds, feed_datatable_length, selectedValue } = this.state
        const { feeds, feedRconnect, getFeed } = this.props;

        return (
            <div className="table-scrollable globalTblList">
                <div id="feed_datatable_wrapper" className="dataTables_wrapper">
                    <div className="col-sm-12 px-0">
                        <table id="feed_datatable" className={`table table-hover dataTable mb-0 ${this.state.width < 768 ? 'dtr-inline collapsed' : null} `} aria-describedby="feed_datatable_info">
                            <thead>
                            <tr>
                                <th className="text-left border-0">Name</th>
                                <th className="text-center border-0 mobileHide">Profile Pic</th>
                                <th className="text-center border-0 mobileHide">Account</th>
                                <th className="text-center border-0 mobileHide">Moderation</th>
                                <th className="text-center border-0 mobileHide">Posts</th>
                                <th className="text-center border-0 mobileHide">Status</th>
                                <th className="text-center border-0 mobileHide">Action</th></tr>
                            </thead>
                        </table>
                        {allFeeds && allFeeds.length && allFeeds[currentPage - 1] && allFeeds[currentPage - 1].length ? allFeeds[currentPage - 1].map((feed, index) => (
                            <>
                                {feed.isBtntext == 'Reconnect' && !this.state.reconnectd ? feedRconnect(this.setState({ reconnectd: true })) : ''}
                                {feed.networkId !=29 && <FeedsRecord feed={feed} index={index} changeStatus={this.changeStatus} onFeedDelete={this.onFeedDelete} changeAccount={this.changeAccount} key={`tr_${feed.id}`} getFeed={getFeed} />}
                            </>
                        )) : null}
                    </div>
                    <div className="col-sm-12">
                        <div className="d-flex flex-wrap pt-4 border-top">
                            <div className="col-sm-12 col-md-5">
                                <div className="dataTables_info" id="feed_datatable_info">
                                    Showing {currentPage == 1 ? currentPage : ((currentPage - 1) * showPost) + 1} to {feeds.length < showPost * currentPage ? feeds.length : showPost * currentPage} of {feeds ? feeds.length : 0}	entries
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-7 dataTables_pager">
                                <select className="form-select w-auto" aria-label="Default select example" value={`${showPost}`} onChange={e=>this.changeTotalPost(e)}>
                                    {feed_datatable_length.map((feeds) => {
                                       return <option value={feeds.value}>{feeds.label}</option>
                                    })}
                                </select>
                                {/* <div className="dataTables_length table-row-select" id="feed_datatable_length">
                                    <label>Show
                                        <Select isSearchable={false} menuPlacement="top" classNamePrefix="selectpicker" className="selectedOptionData mx-2" defaultValue={feed_datatable_length[1]} onChange={e => this.changeTotalPost(e)} options={feed_datatable_length} />
                                        entries
                                    </label>
                                </div> */}
                                <div className="dataTables_paginate paging_simple_numbers ms-2" id="feed_datatable_paginate">
                                    <button className={`paginate_button previous ${currentPage == 1 ? "disabled" : ''} `} disabled={currentPage == 1 ? true : false} id="feed_datatable_previous" onClick={() => { this.nextPrev(currentPage - 1) }}>Previous</button>

                                    {allFeeds && allFeeds.length ? allFeeds.map((allFeeds, i) =>
                                        <span key={i}>
                                            <button className={`paginate_button ${currentPage == i + 1 ? "current" : ''}`} onClick={() => this.setState({ currentPage: i + 1 })}>{i + 1}</button>
                                        </span>) :
                                        <span><button className="paginate_button current">1</button></span>}

                                    <button className={`paginate_button next ${currentPage == totalPage ? "disabled" : ''} `} disabled={currentPage == totalPage ? true : false} id="feed_datatable_next" onClick={() => { this.nextPrev(currentPage + 1) }}>Next</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        ACTION_DELETE_FEED: (feedId, callback) => dispatch(ACTION_DELETE_FEED(feedId, callback)),
        ACTION_FEED_STATUS: (feedId, status, action, callback) => dispatch(ACTION_FEED_STATUS(feedId, status, action, callback)),
        ACTION_UPDATE_SOCIAL_ACCOUNT: (accountId, feedId, callback) => dispatch(ACTION_UPDATE_SOCIAL_ACCOUNT(accountId, feedId, callback)),
        getModeration: () => dispatch(getModeration()),
        removePost:()=>dispatch(getWallFeeds(localStorage.getItem('ownerId'))),
        refreshThemes: () => dispatch(refreshThemes())
    }
}

export default connect(null, mapDispatchToProps)(FeedTable)